import { createSlice } from "@reduxjs/toolkit";
import { FirestoreService } from "../../../../shared/api/firebase/firestoreService";
import { FirestoreCollectionReference } from "../../../../shared/api/firebase/references";
import { ClinicalData } from "../../../data-model/clinicalCondition";
import { AppDispatch } from "../../store/store";

export interface MedicalPaOrderClinicalData {
  data: ClinicalData | null;
  loading: boolean;
  error: string | null;
  unsubscribe?: () => void;
}

const initialState: MedicalPaOrderClinicalData = {
  data: null,
  loading: false,
  error: null,
  unsubscribe: undefined,
};

const medicalPaClinicalDataSlice = createSlice({
  name: "medicalPaClinicalData",
  initialState,
  reducers: {
    fetchingMedicalPaClinicalData: (state) => {
      state.loading = true;
      state.error = null;
      state.data = null;
    },
    setMedicalPaClinicalData: (state, action) => {
      state.data = action.payload;
      state.loading = false;
      state.error = null;
    },
    errorMedicalPaClinicalData: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    setMedicalPaClinicalDataUnsubscribe: (state, action) => {
      state.unsubscribe = action.payload;
    },
    clearMedicalPaClinicalDataUnsubscribe: (state) => {
      state.unsubscribe?.();
      state.unsubscribe = undefined;
    },
    resetMedicalPaClinicalData: (state) => {
      state.data = null;
      state.loading = false;
      state.error = null;
      state.unsubscribe?.();
      state.unsubscribe = undefined;
    },
  },
});

export const {
  fetchingMedicalPaClinicalData,
  setMedicalPaClinicalData,
  errorMedicalPaClinicalData,
  setMedicalPaClinicalDataUnsubscribe,
  clearMedicalPaClinicalDataUnsubscribe,
  resetMedicalPaClinicalData,
} = medicalPaClinicalDataSlice.actions;

export const fetchMedicalPaClinicalData =
  (orderId: string) => async (dispatch: AppDispatch) => {
    dispatch(fetchingMedicalPaClinicalData());
    const unsubscribe = await FirestoreService.listenToDocument<ClinicalData>(
      FirestoreCollectionReference.clinicalDataTable(orderId),
      "condition",
      (document) => {
        if (document) {
          dispatch(setMedicalPaClinicalData(document));
        }
      },
      (error) => {
        dispatch(errorMedicalPaClinicalData(error.message));
      },
    );
    dispatch(setMedicalPaClinicalDataUnsubscribe(unsubscribe));
    return unsubscribe;
  };

export default medicalPaClinicalDataSlice.reducer;
